/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.11.2",
    versionName: "0.8.0-nightly.2026.11.2",
    versionChannel: "nightly",
    buildDate: "2026-11-02T00:14:37.656Z",
    commitHash: "6fdbb6790101eddbe8e64dffe6e81061e63e6214",
};
